import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

setupLogRocketReact(LogRocket);

export const billingPlanCodesToStartImmediately = ['trial'];

const isInactive = process.env.NODE_ENV === 'development';
const staticNetworkUrlsToScrubInLogRocket = [
  'provider/registerstampsaccount',
  'provider/addstampsaccount',
  'profile/changePassword',
  'wallet/register',
  'wallet/registration',
  '/account/v2/getSellerApiKeys',
  '/account/v2/generateSellerApiKeys',
  '/account/getsellerapikeys',
  '/account/generatesellerapikeys',
  '/v2/payment/update',
  '/v2/payment/registration',
];

const regexMatchNetworkUrlsToScrubInLogRocket = ['wallet/.+/payment', 'adyen\\.com'];

export const checkUrls = (url) => {
  const staticMatch = staticNetworkUrlsToScrubInLogRocket.reduce((acc, val) => {
    return acc || url.indexOf(val) !== -1;
  }, false);

  const regexMatch = regexMatchNetworkUrlsToScrubInLogRocket.reduce((acc, val) => {
    const regex = new RegExp(val, 'gi');
    return acc || regex.test(url);
  }, false);

  return staticMatch || regexMatch;
};
class LogRocketAnalyticsServiceClass {
  isInitialized = false;

  init() {
    if (isInactive || this.isInitialized) return;
    this.isInitialized = true;
    LogRocket.init('acns5j/v3-dev', {
      release:
        process.env.RELEASE_VERSION && process.env.RELEASE_VERSION.length ? `shipstation-ui@${process.env.RELEASE_VERSION}` : undefined,
      network: {
        requestSanitizer: (request) => {
          if (checkUrls(request.url.toLowerCase())) {
            return {
              ...request,
              body: null,
            };
          }
          return request;
        },
      },
      rootHostname: '.shipstation.com',
    });
  }

  identifyUser(userId, sellerId, userInfo) {
    if (isInactive) return;
    LogRocket.identify(userId, {
      sellerId,
      ...userInfo,
    });
  }

  // oxlint-disable-next-line no-empty-function
  trackPage() {}

  // oxlint-disable-next-line no-empty-function
  trackEvent() {}
}

export const LogRocketAnalyticsService = new LogRocketAnalyticsServiceClass();
